
import { Component, Vue } from 'nuxt-property-decorator'
import throttle from 'lodash/throttle'

@Component({})
export default class TheScrollTop extends Vue {
  SCROLL_THROTTLE = 1000
  SCROLL_TOP_ICON_VISIBLE = -1300
  HEADER_ELEMENT_ID = 'above-header'
  show = false

  mounted() {
    window.addEventListener('scroll', this.scroll)
  }

  get scroll() {
    return throttle(() => {
      const top = document.body.getBoundingClientRect().top

      this.show = this.SCROLL_TOP_ICON_VISIBLE > top
    }, this.SCROLL_THROTTLE)
  }

  clickScrollTop() {
    const aboveHeader = document.getElementById(
      this.HEADER_ELEMENT_ID
    ) as Element

    this.$scrollTo(aboveHeader, this.SCROLL_THROTTLE)
  }

  destroyed() {
    window.removeEventListener('scroll', this.scroll)
  }
}
